var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVocaWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57133 2.79541V21.9954M17.4856 11.024H12.6856M17.4856 6.9097H12.6856M5.14276 6.9097H2.3999M5.14276 11.024H2.3999M5.14276 15.1383H2.3999M6.51419 21.9954H18.857C20.3719 21.9954 21.5999 20.7674 21.5999 19.2526V5.53827C21.5999 4.02343 20.3719 2.79541 18.857 2.79541H6.51419C4.99935 2.79541 3.77133 4.02343 3.77133 5.53827V19.2526C3.77133 20.7674 4.99935 21.9954 6.51419 21.9954Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVocaWidth2);
export default __webpack_public_path__ + "static/media/voca-width-2.316a8f465ebc564cd16e1f246115893e.svg";
export { ForwardRef as ReactComponent };